module.exports = __webpack_public_path__ + "static/media/back-img.8d13a100.svg";